export const numberLayerFlex = [
  { value: 1, text: '1' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5' },
  { value: 6, text: '6' },
];

export const materialTypeFlex = [
  { value: 'Polyimide', text: 'Polyimide' },
];

export const materialTypeRigidFlex = [
  { value: 'FR4', text: 'FR4 Tg135 + Polyimide' },
  { value: 'FR4TG170', text: 'FR4 Tg170 + Polyimide' },
];

export const finishPlatingFlex = [
  { value: 'ENIG', text: 'ENIG' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
  { value: 'Immersion Tin', text: 'Immersion Tin' },
];

export const silkscreenColor = [
  { value: 'Red', text: 'Red' },
  { value: 'Yellow', text: 'Yellow' },
  { value: 'Black', text: 'Black' },
  { value: 'Green', text: 'Green' },
  { value: 'White', text: 'White' },
];

export const copperOuter = [
  { value: '0.8 oz', text: '0.8 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
];
